/*
  Sometimes we want to do something like:
    - render state A
    - wait for browser to repaint
    - render state B
  (Ie. when changing a color, and then quickly using CSS transition to transition back to original color)

  We can call it from render/componentDidMount/componentDidUpdate, to ensure that the callback
  is only executed after the current DOM values have been painted.

  Note - depending on where the calling code is in the JS event loop, this function might actually wait one
  frame longer than necessary. 

  Do not use this function recursively to implement animations - use requestAnimationFrame directly for that.
*/
export function onNextFrame(callback) {
  /*
    Note - the implementation discussed at https://stackoverflow.com/a/34999925 seems to work from render function
    when that render occurs as a result of calling setState in a React event handler.
    It doesn't work when setState is called from a timeout, however (in which case setState is processed
    synchronously).

    This implementation should always work (ie. wait until AT LEAST the current changes have been painted).
  */
  /*
    Note - it might be possible to make this work like Timer - as a component you render. We might be able to 
    render a button with a click listener, then programmatically create a click event (perhaps inside requestAnimationFrame).
    That would mean callback is executed from inside a React event handler, which means setState would have the
    usual asynchronous behaviour. I'm not sure if that has much advanatage, though, and it probably isn't worth the work.
  */
  requestAnimationFrame(() => requestAnimationFrame(callback));
}

// error will be thrown if array is empty
export function getRandomElement(array) {
  const index = Math.floor(Math.random() * array.length);
  return array[index];
}



// WEBPACK FOOTER //
// ./src/utils.js